import {partsLinkAccess} from './parts-link-access-de.i18n'

export const de = {partsLinkAccess}
